import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { PATHWAY_STEPS, TRIAL_WA } from "../data/content";

export const MinervaPathway = () => (
  <section id="pathway" className="py-24 sm:py-32 scroll-mt-16 bg-[#050505] relative overflow-hidden" data-testid="pathway-section">
    <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "radial-gradient(circle at 30% 20%, #D4AF37 0%, transparent 60%)" }} />
    <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
      <Reveal>
        <Overline>From Zavi to the Next Level</Overline>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-3 max-w-3xl">
          Player <span className="text-[#D4AF37]">Pathway.</span>
        </h2>
      </Reveal>

      {/* Partnership lockup — Minerva first, then Zavi, per user's preferred stacking */}
      <Reveal delay={0.15}>
        <div className="mt-12 border border-white/10 bg-black py-10 px-5 sm:px-10" data-testid="partnership-lockup">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-14">
            <div className="flex flex-col items-center gap-2">
              <img src="/assets/minerva-logo.png?v=gold" alt="Minerva Academy FC" className="h-20 sm:h-24 w-auto" />
              <p className="font-heading text-xs sm:text-sm font-black uppercase tracking-widest">Minerva Academy FC</p>
            </div>
            <p className="font-heading text-xl sm:text-2xl font-black text-[#D4AF37]/70">×</p>
            <div className="flex flex-col items-center gap-2">
              <img src="/logo.png" alt="Zavi Football Club" className="h-20 sm:h-24 w-auto" />
              <p className="font-heading text-xs sm:text-sm font-black uppercase tracking-widest">Zavi FC</p>
            </div>
          </div>
        </div>
      </Reveal>

      {/* Pathway steps */}
      <div className="mt-14 grid md:grid-cols-3 gap-4">
        {PATHWAY_STEPS.map((s, i) => (
          <Reveal key={s.n} delay={0.2 + i * 0.08}>
            <div className={`border border-white/10 p-6 sm:p-7 h-full bg-black ${i === 2 ? "border-[#D4AF37]/40" : "hover:border-[#D4AF37]/30"} transition-colors duration-300`}
                 data-testid={`pathway-step-${s.n}`}>
              <p className="font-heading text-4xl font-black text-[#D4AF37]/40">{s.n}</p>
              <h3 className="font-heading text-xl font-black uppercase tracking-tight mt-3">{s.title}</h3>
              <p className="text-white/60 text-sm mt-3 leading-relaxed">{s.text}</p>
              {s.highlight && (
                <p className="mt-4 text-[#D4AF37] text-[11px] uppercase tracking-[0.2em] font-bold border-t border-[#D4AF37]/30 pt-4">{s.highlight}</p>
              )}
            </div>
          </Reveal>
        ))}
      </div>

      {/* Photo + copy */}
      <Reveal delay={0.5}>
        <div className="mt-14 grid md:grid-cols-2 gap-8 items-center">
          <img
            src="/assets/zavi-minerva.webp"
            alt="Zavi Football Club × Minerva Academy FC — partnership meeting"
            className="w-full h-auto object-cover border border-white/10"
            data-testid="pathway-photo"
            loading="lazy"
          />
          <div>
            <p className="text-white/70 text-[15px] leading-relaxed">
              Through Zavi Football Club's relationship with Minerva Academy FC, outstanding Zavi players can earn opportunities to progress into one of India's leading youth football environments.
            </p>
            <a href={TRIAL_WA} target="_blank" rel="noreferrer"
              className="mt-6 inline-flex items-center gap-2 text-[#D4AF37] text-xs font-bold uppercase tracking-widest hover:gap-3 transition-all"
              data-testid="pathway-explore-cta">
              Explore the Player Pathway <ArrowRight size={14} />
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
